module.exports = __webpack_public_path__ + "static/media/signbridge.ec2b03a1.png";